import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { WizardLeaveDialogComponent } from '@shared/components/wizard-leave-dialog/wizard-leave-dialog.component';
import { EmployeeDetailComponent } from './employee-detail.component';

export const employeeUnsavedChangesGuard: CanDeactivateFn<EmployeeDetailComponent> = (component) => {
  if (!component.hasUnsavedChanges) {
    return true;
  }

  const dialog = inject(MatDialog);
  const translate = inject(TranslateService);
  const dialogRef = dialog.open(WizardLeaveDialogComponent, {
    width: '460px',
    maxWidth: '95vw',
    autoFocus: false,
    restoreFocus: false,
    data: {
      title: translate.instant('employeesCatalog.dialog.unsavedTitle'),
      message: translate.instant('employeesCatalog.dialog.unsavedMessage'),
      stayLabel: translate.instant('employeesCatalog.dialog.stayEditing'),
      leaveLabel: translate.instant('employeesCatalog.dialog.leaveWithoutSaving'),
    },
  });

  return dialogRef.afterClosed().pipe(map((confirmed) => confirmed === true));
};
